export default __webpack_public_path__ + "static/media/blog2.99354e30.png";